export default "__VITE_ASSET__CmHR$8vP__"